export default __webpack_public_path__ + "static/media/product-page3.80b33d0b.png";